import { Component, OnInit } from "@angular/core";
import { ChargesStoreService } from "../services/charges-store.service";
import { Router } from "@angular/router";
import { LoaderService } from "../../../loader/loader.service";
import { environment } from "../../../../environments/environment";
import * as moment from "moment/moment";
import { SingleCharge } from "../models/single-charge";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Title } from "../models/titulos";

@Component({
  selector: "app-onoffcycle-charges",
  templateUrl: "./onoffcycle-charges.component.html",
  styleUrls: ["./onoffcycle-charges.component.scss"],
})
export class OnoffcycleChargesComponent implements OnInit {
  env;
  page = 1;
  pageSize = 10;
  collectionSize = 0;
  singleCharges: SingleCharge[];
  titles: Title[];
  modalActive: NgbModalRef;
  titlesSelected: Title[] = [];
  valueOfTitlesSelected = 0;
  titlesItemSelected = 0;
  singleCharge: SingleCharge;
  errMessage: string;

  private unsubscribe$ = new Subject();

  constructor(
    public router: Router,
    public chargesStore: ChargesStoreService,
    private loaderService: LoaderService,
    private modalService: NgbModal
  ) {
    this.env = environment;
  }
  ngOnInit(): void {
    this.getSingleCharges();
  }

  async getTitlesOfCharge() {
    await this.chargesStore.titlesSingleCharges$.pipe(takeUntil(this.unsubscribe$)).subscribe(titlesResult => {
      console.log(titlesResult.result);
      this.titles = titlesResult.result.map(title => {
        const year = title.vencto.substring(0, 4);
        const month = title.vencto.substring(4, 6);
        const day = title.vencto.substring(6, 8);
        return { ...title, vencto: `${day}/${month}/${year}` };
      });
    });
  }
  clearSelection() {
    this.titlesSelected = [];
    this.titlesItemSelected = 0;
    if (this.titles) {
      this.titles.forEach(title => (title.selected = false));
    }
  }
  toggleSelection(title: any): void {
    title.selected = !title.selected;
    this.onChangeSelectionTitle(title);
  }

  async openSingleChargeModal(singleCharge: SingleCharge, modal) {
    this.singleCharge = { ...singleCharge };
    await this.chargesStore.getTitleSingleCharges(
      this.env.selected.cnpj,
      50,
      1,
      this.singleCharge.contrato,
      this.singleCharge.cgc_cliente
    );
    this.modalActive = this.modalService.open(modal, { size: "lg", centered: true });
    await this.getTitlesOfCharge();
  }

  getSingleCharges() {
    this.chargesStore.singleCharges$.pipe(takeUntil(this.unsubscribe$)).subscribe(singleChargeResult => {
      this.pageSize = singleChargeResult.limit;
      this.page = singleChargeResult.page;

      this.collectionSize =
        singleChargeResult.total_docs !== undefined && singleChargeResult.total_docs !== null
          ? singleChargeResult.total_docs
          : singleChargeResult.result.length;
      this.singleCharges = singleChargeResult.result;
    });
  }
  onChangeSelectionTitle(title: Title) {
    if (title.selected) {
      if (this.titlesSelected.length >= this.singleCharge.quantidade_parcelas) {
        title.selected = false;
        this.errMessage = `Você pode selecionar no máximo ${this.singleCharge.quantidade_parcelas} títulos.`;
        return;
      }
      const selectedIndex = this.titlesSelected.findIndex(selected => selected.chave === title.chave);
      if (selectedIndex === -1) {
        this.titlesSelected.push(title);
      }
    } else {
      this.titlesSelected = this.titlesSelected.filter(selected => selected.chave !== title.chave);
    }
    this.valueOfTitlesSelected = this.titlesSelected.reduce((acc, title) => {
      return acc + title.valor_titulo;
    }, 0);
    this.titlesItemSelected = this.titlesSelected.length;
  }

  async onChangePagination() {
    const loader = await this.loaderService.notifica({
      title: "Atualizando paginação...",
      date: moment().toISOString(),
      type: "loading",
    });

    await this.chargesStore.getSingleCharges(this.env.selected.cnpj, this.pageSize, this.page);
    loader.dismiss();
  }
  onClose() {
    this.modalActive.close();
    this.clearSelection();
    this.errMessage = "";
  }
  async onConfirmLinked() {
    try {
      if (this.titlesSelected.length !== this.singleCharge.quantidade_parcelas) {
        this.errMessage = "Ainda há titulos a serem selecionados";
        return;
      }
      if (this.singleCharge.valor_pago !== this.valueOfTitlesSelected) {
        this.errMessage = "Valor pago deve ser igual ao valor dos títulos selecionados";
        return;
      }
      await this.chargesStore.saveSingleChargeLink(
        this.singleCharge.cobrador,
        this.env.selected.cnpj,
        this.titlesSelected,
        this.singleCharge
      );
      await this.onChangePagination();

      this.modalActive.close();
      this.errMessage = "";
    } catch (error) {
      this.errMessage = (error as Error).message;
    }
  }
}
